import { render } from "./AccordionPage.vue?vue&type=template&id=d73eb084"
import script from "./AccordionPage.vue?vue&type=script&lang=js"
export * from "./AccordionPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__